import redirectSource from './AvatarRedirect';
export default redirectSource('twitter', 'twitterHandle');